module.exports = __webpack_public_path__ + "static/assets/bd00845d7d09a355c66ac7951fcf5c8c.png";